/**
 * O tipo da operação como ícone, com o nome por extenso no tooltip — o mesmo desenho da Lista de
 * Contratos, que é de onde ele saiu (AF-4142).
 *
 * `DRAWEE_RISK` não é um `operation_type` do banco: o Risco Sacado é uma cessão com produto
 * `RISCO_SACADO`, e só a Lista de Contratos o resolve (pelo produto) antes de chamar o ícone. As
 * telas de cobrança passam o `operationType` cru e mostram o Risco Sacado como Cessão.
 *
 * Tipo nulo ou desconhecido vira "—": um ícone de outro tipo afirmaria o que não se sabe.
 */
import { IconType } from 'react-icons';
import { FaFileExport, FaFileSignature, FaHandHoldingUsd, FaLayerGroup, FaShieldAlt } from 'react-icons/fa';
import NewTooltip from '../atoms/NewTooltip';

interface Props {
    type?: string | null;
}

const ICONS: Record<string, { label: string; Icon: IconType; color: string }> = {
    LOAN: { label: 'Empréstimo', Icon: FaHandHoldingUsd, color: 'text-blue-600 dark:text-blue-400' },
    RECEIVABLES_ASSIGNMENT: { label: 'Cessão de recebíveis', Icon: FaFileExport, color: 'text-green-600 dark:text-green-400' },
    STRUCTURED_OPERATION: { label: 'Operação estruturada', Icon: FaLayerGroup, color: 'text-purple-600 dark:text-purple-400' },
    ACKNOWLEDGEMENT_OF_DEBT: { label: 'Confissão de dívida', Icon: FaFileSignature, color: 'text-orange-600 dark:text-orange-400' },
    DRAWEE_RISK: { label: 'Risco Sacado', Icon: FaShieldAlt, color: 'text-teal-600 dark:text-teal-400' },
};

/** O nome por extenso, para a planilha; vazio quando o tipo não é conhecido. */
export const operationTypeLabel = (type?: string | null): string => (type && ICONS[type]?.label) || '';

const OperationTypeIcon: React.FC<Props> = ({ type }) => {
    const entry = type ? ICONS[type] : undefined;
    if (!entry) return <>—</>;
    const { label, Icon, color } = entry;
    return (
        <NewTooltip content={label}>
            <Icon role="img" aria-label={label} className={`${color} text-lg inline-block`} />
        </NewTooltip>
    );
};

export default OperationTypeIcon;
